const uppercase = string => {
    if (typeof string !== 'string') return '';
    let splitString = '';

    if (string.match(/[A-Z][a-z]+/g)) {
        splitString = string.match(/([A-Z]?[^A-Z]*)/g).slice(0, -1);
    } else {
        splitString = string.split(' ');
    }

    return splitString.map(string => string.charAt(0).toUpperCase() + string.slice(1)).join(' ');
};

export default uppercase;
